import React from 'react';
import MasterclassSectionLayout from '../Layouts/MasterclassSectionLayout';
import RawHTML from '@components/Common/RawHTML';
import useRegisterMetadata from '@src/hooks/Masterclass/useRegisterMetadata';

export default function AboutCrioDo() {
  const { getAboutCrioDo, getAboutCrioImg, getPastAndUpcomingEvents } =
    useRegisterMetadata();
  const { events } = getPastAndUpcomingEvents() || [];

  const aboutCrioDo = getAboutCrioDo();
  const aboutCrioImg = getAboutCrioImg();
  return (
    <MasterclassSectionLayout
      layoutClassName={`container grid grid-cols-1 pt-[26px] md:pt-12 lg:grid-cols-[1.4fr_1fr] ${
        events.length === 0 ? 'md:pb-[120px]' : ''
      }`}
      heading={'About Crio.Do'}
      sectionWrapperClassName={'md:gap-[30px] gap-[18px]'}
      sectionImage={aboutCrioImg}
      headingClassName={'md:py-9 md:px-7 shadow-[0px_4px_9.4px_0px_#00000014]'}
    >
      <RawHTML className="font-rubik text-[12px] leading-normal md:text-[18px] md:leading-[28px]">
        {aboutCrioDo}
      </RawHTML>
    </MasterclassSectionLayout>
  );
}
